<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-16 15:08:49
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-20 14:28:29
-->
<template>
    <el-main>
        <div class="top-wrap">
            <Bread></Bread>
            <div class="title">
                <el-form ref="filterForm" :inline="true" :model="filterForm" class="filter-form">
                    <el-form-item prop="applyTime" class="my-applyTime">
                        <el-date-picker
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            clearable
                            v-model="applyDate"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="申请开始时间"
                            end-placeholder="申请结束时间"
                            @change="changeApplyDate"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item prop="countyId">
                        <el-cascader
                        ref="regionCascader"
                        :options="regionData"
                        :props="regionProps"
                        v-model="checkedRegionData"
                        @change="handleRegionChange(checkedRegionData)"
                        placeholder="所属地区"
                        clearable
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item prop="bankName">
                        <!-- <el-input class="city-select" v-model="filterForm.bankName" placeholder="金融机构名称"></el-input> -->
                        <el-autocomplete v-model="filterForm.bankName" :fetch-suggestions="bankAssociate" placeholder="金融机构名称" 
                            label="name" value="value" value-key="name" :trigger-on-focus="false"></el-autocomplete>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleFilter()">查询</el-button>
                        <el-button type="primary" plain icon="el-icon-refresh-right" @click="handleReset('filterForm')">
                            清空
                        </el-button>
                    </el-form-item>
                </el-form>
                <span class="export" @click="handleToExport">导出</span>
            </div>
        </div>
        <div class="main">
            <!-- 列表数据 -->
            <el-table :data="tableData" style="width: 100%; margin-top: 10px">
                <el-table-column label="序号" width="80" align="center">
                    <template slot-scope="scope">
                        {{
                            (pagination.currentPage - 1) * pagination.pageSize +
                            (scope.$index + 1)
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="申请时间" min-width="10%" align="center">
                </el-table-column>
                <el-table-column prop="personName" label="申请人姓名" min-width="12%" align="center">
                </el-table-column>
                <el-table-column prop="mobile" label="手机号" min-width="15%" align="center">
                </el-table-column>
                <el-table-column prop="region" label="所属地区" min-width="20%" align="center">
                </el-table-column>
                <el-table-column prop="productName" label="贷款产品名称" min-width="20%" align="center">
                </el-table-column>
                <el-table-column prop="bankName" label="金融机构" min-width="15%" align="center">
                </el-table-column>
                <el-table-column prop="businessOutlets" label="业务网点" min-width="15%" align="center">
                </el-table-column>
                <el-table-column label="操作" min-width="10%" align="center">
                    <template slot-scope="{ row }">
                        <el-button type="primary" plain round size="small" @click="handleToDetail(row)">查看
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="total,prev, pager, next,jumper" :page-size="pagination.pageSize"
                :total="pagination.total" :hide-on-single-page="true" @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </el-main>
</template>
<script>
import { exportFile } from "@/api/downloadRequest";
import regionSeatLibs from '@/utils/regionSeatLibs.js'
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c))
export default {
    name: 'MoneyIntentionList',
    data() {
        return {
            filterForm: {
                applyDate:'',
                bankName:'',
                startTime:'',
                endTime:''
            },
            regionProps: {
                value: 'i',
                label: 'n',
                children: 'c',
                checkStrictly: true
            },
            checkedRegionData:[],
            regionData: regionData,
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
            tableData: [],
            applyDate:''
        };
    },
    created() {
        this.getFinanceLoanIntentionList();
    },
    methods: {
        //页码切换
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            this.getFinanceLoanIntentionList();
        },
        // 获取列表数据
        getFinanceLoanIntentionList() {
            let params = {
                ...this.filterForm,
                isOwner:0,
                currentPage:this.pagination.currentPage,
                pageSize:this.pagination.pageSize
            }
            this.$http.bank.getFinanceLoanIntentionList(params).then(res => {
                this.pagination.total = res.data.recordTotal;
                this.$set(this,'tableData',res.data.content)
            })
        },
        // 导出
        handleToExport(){
            this.$http.bank.financeLoanIntentionExport({...this.filterForm,isOwner:0}).then( res => {
                exportFile(res.data, "贷款意向查询列表", "xlsx");
            })
        },
        // 下拉补贴地区选完关闭
        handleRegionChange(val) {
            this.$refs.regionCascader.dropDownVisible = false
            let _params = this.filterForm
            _params.provinceId = val[0] || ''
            _params.cityId = val[1] || ''
            _params.countyId = val[2] || ''
        },
        // 跳详情
        handleToDetail(row){
            this.$router.push({
                path:'/money/intention/detail',
                query:{
                    id:row.id,
                    businessOutlets:row.businessOutlets,
                    region:row.region
                }
            })
        },
        // 查询
        handleFilter() {
            this.pagination.currentPage = 1;
            this.getFinanceLoanIntentionList();
        },
        //重置
        handleReset(formName) {
            this.$refs[formName].resetFields();
            this.checkedRegionData = []
            this.applyDate = ''
            let _params = this.filterForm
            _params.provinceId = ''
            _params.cityId = ''
            _params.countyId = ''
            _params.startTime = ''
            _params.endTime = ''
            setTimeout(() => {
                this.handleFilter();
            }, 500);
        },
        // 银行机构
        bankAssociate(key,cb) {
            if (key !== '') {
                this.loading = true;
                this.$http.bank.fuzzyQueryList({key}).then( ({data}) => {
                this.loading = false;
                let arr = data.map( (item,index) => ({name:item,value:index}));
                cb(arr) // 渲染回调
                }).catch( res => {
                this.loading = false;
                })
            }
        },
        changeApplyDate(val) {
            if (val && val.length > 1) {
                this.filterForm.startTime = val[0];
                this.filterForm.endTime = val[1];
            } else {
                this.filterForm.startTime = "";
                this.filterForm.endTime = "";
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.top-wrap {
    .title {
        display: flex;
        justify-content: space-between;
        .export {
            display: inline-block;
            width: 85px;
            height: 42px;
            text-align: center;
            line-height: 40px;
            background: #018388;
            color: #fff;
            border-radius: 5px;
            cursor: pointer;
        }
    }
}
.city-select {
    width: 160px;
}
::v-deep {
    .my-applyTime {
        width: 290px !important;
    }
}
</style>
